var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ 'btn-next' : _vm.isNext, 'btn-previous' : _vm.isPrevious, 'btn-danger' : _vm.isDanger },style:(_vm.addStyle),attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }